import { render } from "./ThemeImagesPage.vue?vue&type=template&id=05f294c6"
import script from "./ThemeImagesPage.vue?vue&type=script&lang=js"
export * from "./ThemeImagesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__